import toShortPercentage from "./toShortPercentage";
export default v => (v < 0 ? "0%" : toShortPercentage(v));
